import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export const HistoryIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Clock face */}
      <circle cx="12" cy="12" r="10" />

      {/* Clock hands */}
      <path d="M12 6V12L16 14" />

      {/* Circular arrow indicating history/going back in time */}
      <path d="M4.5 7.5C5.24 6.43 6.43 5.24 7.5 4.5" />
      <path
        d="M2 12C2 9.28 3.14 6.56 5.5 4.5"
        strokeWidth={strokeWidth * 0.8}
      />
      <path
        d="M2 12C2 11.8 2 11.53 2.04 11.33"
        strokeWidth={strokeWidth * 0.8}
      />
    </svg>
  )
}

export default HistoryIcon
